import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ReportsService = {
    list: async () => axios.post(API_URL + "/reports/list").then(({ data }) => data.data),

    toggleFavorite: async (id) => axios.post(API_URL + "/reports/toggleFavorite", { id }).then(({ data }) => data.data)
};

export default ReportsService;